module.exports = __webpack_public_path__ + "static/img/14000700.7c691db9.png";